import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OneDriveAuthService } from 'src/app/services/cloud-storage/one-drive/one-drive.auth.service';
// import { EventBus } from 'src/app/services/auth/event.bus';
// import { EventTypeEnum } from '../enums';


@Injectable()
export class OneDriveInterceptor implements HttpInterceptor {
    private oneDriveApiUrl: string = 'https://graph.microsoft.com/v1.0/';

    constructor(
        private readonly oneDriveAuthService: OneDriveAuthService,
        // private readonly eventBus: EventBus
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.url.startsWith(this.oneDriveApiUrl)) {
            return next.handle(request);
        }

        const observable = new Observable<HttpEvent<any>>((observer: any) => {
            const onSuccess = (resp: HttpResponse<any>) => {
                observer.next(resp);
            };

            const onComplete = () => observer.complete();

            const onError = async (error: HttpErrorResponse) => {
                try {
                    if (error.status === 401) {
                        this.oneDriveAuthService.authorizeOneDrive();
                    } else {
                        // this functionality was commented because it makes impossible handling onedrive service errors
                        // in CloudDlgManagerService in general (for all cloud providers) error processing code block
                        // this.eventBus.emit(EventTypeEnum.ONE_DRIVE_ERROR, error);
                        observer.error(error);
                    }
                } catch (e) {
                    onError(error);
                }
            };

            next.handle(this.prepare(request)).subscribe({
                next: onSuccess,
                error: onError,
                complete: onComplete,
            });
        });

        return observable;
    }

    private prepare(request: HttpRequest<any>): HttpRequest<any> {
        const oneDriveInfo = this.oneDriveAuthService.oneDriveInfo;

        if (oneDriveInfo) {
            request = request.clone({
                setHeaders: {
                    Authorization: `${oneDriveInfo.token_type} ${oneDriveInfo.access_token}`
                }
            });
        }

        return request;
    }
}
